<template>
  <div class="flex items-center gap-3">
    <button
      type="button"
      @click="handleGoBack"
      :class="[
        'w-9 h-9 flex items-center justify-center bg-white border border-gray-200 rounded-lg transition-colors text-gray-500',
        noHover ? '' : 'hover:bg-gray-50 hover:border-primary hover:text-primary'
      ]"
    >
      <i class="fa-solid fa-arrow-left text-sm"></i>
    </button>
    <h3 class="text-base font-semibold text-gray-900 mb-0">{{ title }}</h3>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import { useRouter } from 'vue-router'

export default defineComponent({
  name: 'GoBackTitle',
  props: {
    title: {
      type: String,
      required: true
    },
    to: {
      type: [String, Object],
      default: null
    },
    onBack: {
      type: Function,
      default: null
    },
    noHover: {
      type: Boolean,
      default: false
    }
  },
  emits: ['back'],
  setup(props, { emit }) {
    const router = useRouter()

    const handleGoBack = () => {
      emit('back')

      if (props.onBack) {
        props.onBack()
        return
      }

      if (props.to) {
        router.push(props.to)
        return
      }

      router.back()
    }

    return {
      handleGoBack
    }
  }
})
</script>
